import { ReduxStore } from 'store/types';

function addDocumentIsLoading(state: ReduxStore): boolean {
  return state.intervention.addDocument.config.isLoading;
}

export default addDocumentIsLoading;
